<template>
    <div class="member-check">
        <div class="member-check-box">
            <div class="member-check-close" @click="handleClose">
                <i class="x-icon icon-guanbi"></i>
            </div>
            <div class="member-check-content">
                <div class="member-check-content-bg"><img src="../../content/images/member/member-chek-bg.png" /></div>
                <div class="member-check-content-btn" @click="goVip"><img src="../../content/images/member/member-chek-bg-btn.png"/></div>
            </div>

        </div>
    </div>
</template>
<script>
    export default {
        data () {
            return {}
        },
        methods: {
            handleClose () {
                this.$emit('isShow',false)
            },
            goVip () {
                window.location.href="https://yingxiao.xuanwo001.com/#/member?hmsr=%E9%A6%96%E9%A1%B5%E8%90%A5%E9%94%80%E5%8A%9B%E6%AC%A1%E6%95%B0banner&hmpl=&hmcu=&hmkw=&hmci="
            }
        }
    }
</script>
<style lang="scss" scoped>
    .member-check{
        p{
            margin-block-start: 0em;
            margin-block-end: 0em;
        }
        position: fixed;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.7);
        z-index: 112;
        .member-check-box{
            width: 33.3rem;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .member-check-close{
                cursor: pointer;
                i{
                    font-size: 2rem;
                    color: #fff;
                    position: absolute;
                    top:-1rem;
                    right: 0;
                }
            }
        }

    }
    .member-check-content{

        width: 30.9rem;
        position: relative;
        .member-check-content-bg{
            width: 100%;
            img{width: 100%}
        }
        .member-check-content-btn{
            width: 12rem;
            cursor: pointer;
            position: absolute;;
            bottom:2.65rem;
            left: 9rem;
            img{width: 100%}
        }
    }
</style>



// WEBPACK FOOTER //
// app/view/member/memberCheck.vue